import { Text } from '@shared/components/Text';
import { DateField } from '@shared/data/entity/fields/DateField';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: DateField;
}

export function DateCollectionViewField({ field }: Props) {
  if (field.isEmpty) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer fieldType={field.fieldType}>
      <Text size="body1" numberOfLines={1}>
        {field.formattedDate}
      </Text>
    </CardCollectionViewFieldContainer>
  );
}
